import { IInventoryPage } from '../../../inventory-page.interface';


export const UPLOAD_UPLOAD_SETUP_KDP_UPLOADER_PAGE: IInventoryPage = {
	'route': '/upload/upload/setup-kdp-uploader',
	'title': 'Setup KDP Uploader',
	'uiReference': [
		'What is the KDP Uploader?',
		'Step 1: Installation',
		'Easy-peasy installation process with this video. From downloading the application till the start of the main application. Remember: Never move your original files, always start with the launcher, like in the video!',
		'Uploader - Windows',
		'Uploader - macOS',
		'Without Setup - Windows',
		'Installation Guide macOS',
		'Step 2: Overview & Usage',
		'Here is a general overview, what FU can do for you. From the edit, to the upload and also your language settings. A small hint of all the extra functions Flying Upload offers for you!',
		'See all Tutorials',
		'See Shortcuts',
		'Excel Standard',
		'Additional setup resources',
		'Start'
	],
	'sources': [
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/upload/upload-routing.module.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/upload/setup-kdp-uploader/setup-kdp-uploader.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/upload/setup-kdp-uploader/setup-kdp-uploader.data.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/upload/setup-kdp-uploader/setup-kdp-uploader.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/upload/shared/setup-uploader/setup-uploader.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/upload/shared/setup-uploader/setup-uploader.component.html'
	],
	'aliases': []
};
